import { RESET_NOTIFICATION, SET_NOTIFICATION_COUNT } from '../actions/types';

// count starts at 0, not ''. MUI's useBadge only treats the literal 0 as invisible
// (`badgeContentProp === 0 && !showZero`), so an empty string rendered a blank coloured badge
// on every page load until the first /notificationscount response arrived — which reads as
// "you have something waiting" and then vanishes.
const initialState = {
    count: 0,
    lastFive: []
}

export default function notificationReducer(state = initialState, action){
    switch(action.type){
        case SET_NOTIFICATION_COUNT: {
            return {
                ...state,
                count: action.payload.count.count,
                lastFive: action.payload.count.lastFive
            }
        }
        case RESET_NOTIFICATION: {
            return initialState;
        }
        default:
            return state;
    }
}